import {swiper, swiperSlide} from 'vue-awesome-swiper';
import SolrService from '../../common/solr.service';
import '@/assets/swiper/swiper.css';

export default {
  name: 'NewsModalContent',
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      exhibitor: null,
    };
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    existingEntries: {
      type: Array,
      default: [],
    },
    isFavourite: {
      type: Function,
      required: true,
    }
  },
  methods: {
    setFavourite(entryId) {
      this.$emit('set-favourite', entryId);
    },
  },
  mounted() {
    if (this.entry.exhibitor_id) {
      this.exhibitor = SolrService.getExhibitorForNews(`MkdbExhibitorIndexBundle|||Documents|||Exhibitor|||${this.entry.exhibitor_id}`)
        .then((response) => {
          this.exhibitor = response.data.response.docs[0]; // eslint-disable-line
          this.$forceUpdate();
        });
    }
  },
  computed: {
    newsImages() {
      let images = [];
      if (typeof this.entry.av_news_image_url === 'string') {
        images = JSON.parse(this.entry.av_news_image_url);
      }
      return images.filter(i => i !== '');
    }
  }
};
